import { render, staticRenderFns } from "./EPurseTransfers.vue?vue&type=template&id=afc9d008&scoped=true&"
import script from "./EPurseTransfers.vue?vue&type=script&lang=js&"
export * from "./EPurseTransfers.vue?vue&type=script&lang=js&"
import style0 from "./EPurseTransfers.vue?vue&type=style&index=0&id=afc9d008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc9d008",
  null
  
)

export default component.exports